import { Box } from '@chakra-ui/react';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';

export default function AppAdminCreateUserForm({
	handleChange,
	localPageState,
	isInvalidEmail
}) {

	const { emailInput, nameInput } = localPageState || {};

	return (
		<Box my='2em' w='100%' gap='0.5em'>
			<Box mb='0.5em'>
				<LaunchdeckFormInput
					label='User email'
					name={'emailInput'}
					onChange={handleChange}
					value={emailInput}
					isRequired={true}

					errorLogic={isInvalidEmail}
					errorMessage={'Please provide a valid email'}
				/>
			</Box>

			<Box mb='0.5em'>
				<LaunchdeckFormInput
					label='User name'
					name={'nameInput'}
					onChange={handleChange}
					value={nameInput}
				/>

			</Box>

			<Box />

		</Box>
	);
};